/**
 * 台灣縣市/鄉鎮區共用工具，給「公用訂車表單 V2」的區域選單跟「設定 → 公用區域設定」共用，
 * 確保兩邊拆縣市/排序的邏輯完全一致。
 */

// 台灣縣市清單，用來把匯入的「縣市+鄉鎮區」組合字串（例如「台北市中正區」）反拆回兩層
export const TAIWAN_COUNTIES = [
  '台北市', '新北市', '基隆市', '桃園市', '新竹市', '新竹縣', '苗栗縣', '台中市',
  '彰化縣', '南投縣', '雲林縣', '嘉義市', '嘉義縣', '台南市', '高雄市', '屏東縣',
  '宜蘭縣', '花蓮縣', '台東縣', '澎湖縣', '金門縣', '連江縣',
].sort((a, b) => b.length - a.length)

export const OTHER_COUNTY = '其他地區'

export interface RegionOrder {
  counties: string[]
  districts: Record<string, string[]>
}

export const EMPTY_REGION_ORDER: RegionOrder = { counties: [], districts: {} }

/** 把 regions（可能是「台北市中正區」這種縣市+鄉鎮區組合，也可能是沒有縣市前綴的舊資料如「湖口」）
 *  依縣市分組，方便畫面上先選縣市、再選鄉鎮區。反解析不到縣市前綴的一律歸到「其他地區」。*/
export function groupRegionsByCounty(regions: string[]): Map<string, { region: string; district: string }[]> {
  const groups = new Map<string, { region: string; district: string }[]>()
  for (const region of regions) {
    const county = TAIWAN_COUNTIES.find(c => region.startsWith(c))
    const key = county || OTHER_COUNTY
    const district = county ? region.slice(county.length) || county : region
    if (!groups.has(key)) groups.set(key, [])
    groups.get(key)!.push({ region, district })
  }
  return groups
}

/** 穩定排序：priority 陣列裡列出的 key 依序排最前面，其餘項目維持原本的相對順序不變 */
export function sortByPriority<T>(items: T[], priority: string[], keyFn: (item: T) => string = (item) => item as unknown as string): T[] {
  return [...items].sort((a, b) => {
    const ai = priority.indexOf(keyFn(a))
    const bi = priority.indexOf(keyFn(b))
    if (ai === -1 && bi === -1) return 0
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })
}
